import { render, staticRenderFns } from "./ShowSeriennummer.vue?vue&type=template&id=dc47c770"
import script from "./ShowSeriennummer.vue?vue&type=script&lang=js"
export * from "./ShowSeriennummer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports